/**
 * Part of starter project.
 *
 * @copyright  Copyright (C) 2021 __ORGANIZATION__.
 * @license    __LICENSE__
 */

import u from '@main';
import '@vendor/aos/dist/aos.js?99141f134376ef9b3794c167';
import '@vendor/swiper/swiper-bundle.min.js?99141f134376ef9b3794c167';
import '@vendor/odometer/odometer.min.js?99141f134376ef9b3794c167';

u.importCSS('@vendor/aos/dist/aos.css');
u.importCSS('@vendor/odometer/themes/odometer-theme-default.css');

AOS.init({
  duration: 1200,
});

$(() => {
  // 首頁banner輪播
  const bannerSwiper = new Swiper('.j-banner-swiper', {
    speed: 1000,
    loop: true,
    navigation: {
      nextEl: '.c-banner-btn--next',
      prevEl: '.c-banner-btn--prev',
    },
    pagination: {
      el: '.j-banner-swiper-pagination',
      clickable: true,
    },
    autoplay: {
      delay: 2000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true
    },
  });

  // 首頁achievement 輪播
  const achievementSwiper = new Swiper('.j-achievement-swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    grid: {
      rows: 1,
    },
    breakpoints: {
      767: {
        slidesPerView: 3,
        spaceBetween: 20,
        grid: {
          rows: 2,
        },
      }
    },

    navigation: {
      nextEl: '.c-achievement-btn--next',
      prevEl: '.c-achievement-btn--prev',
    },

    pagination: {
      el: '.j-achievement-swiper-pagination',
      clickable: true,
    },
  });

  // 首頁news 輪播
  const newsSwiper = new Swiper('.j-news-swiper', {
    slidesPerView: 1,
    spaceBetween: 30,
    grid: {
      rows: 1,
    },
    breakpoints: {
      767: {
        slidesPerView: 4,
        spaceBetween: 24,
        grid: {
          rows: 2,
        },
      }
    },
    navigation: {
      nextEl: '.j-news-btn--next',
      prevEl: '.j-news-btn--prev',
    },
    pagination: {
      el: '.j-news-swiper-pagination',
      clickable: true,
    }
  });

  // 數字跳動
  $(window).on('scroll', (e) => {
    const chooseOffsetTop = $('.l-choose').offset().top;

    if (e.currentTarget.scrollY > chooseOffsetTop) {
      const jumpingNumber = $('.js-jumping-number');
      const odometer1 = new Odometer(
        {
          el: jumpingNumber[0],
          value: 0,
        });
      const odometer2 = new Odometer(
        {
          el: jumpingNumber[1],
          value: 0,
        });
      const odometer3 = new Odometer(
        {
          el: jumpingNumber[2],
          value: 0,
        });
      const odometer4 = new Odometer(
        {
          el: jumpingNumber[3],
          value: 0,
        });

      odometer1.update(jumpingNumber.eq(0).data('target'));
      odometer2.update(jumpingNumber.eq(1).data('target'));
      odometer3.update(jumpingNumber.eq(2).data('target'));
      odometer4.update(jumpingNumber.eq(3).data('target'));
    }
  });
});
